import { transport } from 'config/transport';

export function callApiCreateDanhMucCTPV(congDoanId, body) {
    return transport.post(`/ctpv/danhmuc/congDoan/${congDoanId}`, body);
}
